import find from 'lodash/find';
import isEqual from 'lodash/isEqual';

type pendingCallsType = Array<{
  args: Array<any> | void;
  promise: Promise<any> | void;
}>;

// https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API

function findPending(currentArgs: any[], pendingCalls: pendingCallsType) {
  // shortcut
  if (pendingCalls.length === 0) {
    return;
  }
  return find(pendingCalls, ({args}) => isEqual(args, currentArgs));
}

export function whenVisible(func) {
  // this acts as decorator to "func" which if called when
  // current window isn't focused, will wait it get focused to
  // call "func" and return it's return value

  // a new promise is stored every time func is called with different params
  // this function always returns a promise

  let pendingCalls: pendingCallsType = [];

  return function (...args): Promise<any> {
    const pending = findPending(args, pendingCalls);

    if (pending && pending.promise != null) {
      return pending.promise;
    }

    // handles not-supported and visible page
    if (!document.hidden) {
      return Promise.resolve(func(...args));
    }

    const promise = new Promise((resolve) => {
      function run() {
        if (!document.hidden) {
          // function will be executed so remove it from pending list
          pendingCalls[promiseIndex] = {
            args: undefined,
            promise: undefined,
          };
          document.removeEventListener('visibilitychange', run);
          return resolve(func(...args));
        }
      }
      document.addEventListener('visibilitychange', run);
    });

    // save index where the promise was put so it can be used to remove
    // it from list when the func get executed
    let promiseIndex = pendingCalls.push({promise, args}) - 1;
    return promise;
  };
}
